import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  CardActions,
  CircularProgress,
  Snackbar,
  Alert,
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

const VideoCall = ({ videoCallHardware, onVideoCallDelete, onPaymentAdd }) => {
  const [isMoving, setIsMoving] = React.useState(false);
  const [showThumbUp, setShowThumbUp] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleMoveToPayment = (row) => {
    setIsMoving(true);
    onPaymentAdd(row);
    setTimeout(() => {
      setIsMoving(false);
      setShowThumbUp(true);
      setOpenSnackbar(true);
      setTimeout(() => {
        setShowThumbUp(false);
      }, 1000); // Duration for thumb-up icon
    }, 1000); // Simulate animation duration
  };

  return (
    <Box sx={{ p: 3 }}>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          Moved to payment!
        </Alert>
      </Snackbar>
      <Typography variant="h4" gutterBottom>
        Video Call
      </Typography>
      <Grid container spacing={3}>
        {videoCallHardware && videoCallHardware.length > 0 ? (
          videoCallHardware.map((row) => (
            <Grid item xs={12} key={row.id}>
              <Card sx={{ boxShadow: 3, border: '1px solid #1976d2' }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {row['Customer Name']}
                  </Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Place:</strong> {row.Place}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Date:</strong> {row.Date}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Time:</strong> {row.Time}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Serial No:</strong> {row['Serial No']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>System Name:</strong> {row['System Name']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Contact Number:</strong> {row['Contact Number']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer ID:</strong> {row['Customer ID']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Address:</strong> {row.Address}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer Issue:</strong> {row['Customer Issue']}</Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="success"
                    onClick={() => handleMoveToPayment(row)}
                    disabled={isMoving || showThumbUp}
                    sx={{
                      border: showThumbUp ? '1px solid green' : '1px solid transparent',
                      transition: 'border-color 0.3s ease-in-out',
                    }}
                  >
                    {isMoving ? <CircularProgress size={20} color="inherit" /> : (showThumbUp ? <ThumbUpIcon /> : 'Move to Payment')}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1">No video calls.</Typography>
        )}
      </Grid>
    </Box>
  );
};

export default VideoCall;